import {
	defaultEqmInspectResultDetailDto,
	EqmInspectResultDetailDto,
	EqmInspectResultHeaderDto,
} from "src/dtos/eqmInspectResult/eqmInspectResultDto";

export interface EQM2070_R01Dto {
	inspectResultHeaderDto: EQM2070_R01HeaderDto;
	inspectResultDetailDtoList: EQM2070_R01DetailDto[];
}

export interface EQM2070_R01HeaderDto extends EqmInspectResultHeaderDto {

}

export const defaultEQM2070_R01HeaderDto: EQM2070_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	inspectNo: '',
	compCd: '',
	compNm: '',
	equipmentCd: '',
	equipmentNm: '',
	inspectDt: undefined,
	inspectCycle: '',
	inspectCycleNm: '',
	judgeResult: '',
	judgeResultNm: '',
	judgeEmpno: '',
	judgeEmpNm: '',
	approvorEmpno: '',
	approvorEmpNm: '',
	remark: '',

	inserted: false,
	isModified: false,
};

/** 점검기준 마스터 (inspect API 응답 / pivot 행 bootstrap용) */
export interface EQM2070_R01InspectMasterDto {
	eqmType: string;
	eqmTypeNm?: string;
	inspectCd: string;
	inspectNm: string;
}

export interface EQM2070_R01DetailDto extends EqmInspectResultDetailDto {
	eqmType?: string;
	eqmTypeNm?: string;
}

export const defaultEQM2070_R01DetailDto: EQM2070_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	inspectNo: '',
	itemNo: '',
	compCd: '',
	equipmentCd: '',
	inspectCd: '',
	inspectCycle: '',
	inspectDt: undefined,
	inspectMethod: '',
	standardValue: '',
	inspectValue: '',
	inspectValue2: '',
	judgeResult: '',
	judgeResultNm: '',
	judgeEmpno: '',
	judgeEmpNm: '',
	actionResult: '',
	remark: '',

	inspectNm: '',
	inspectType: '',
	inspectTypeNm: '',
	valueType: '',
	valueTypeNm: '',

	eqmType: '',
	eqmTypeNm: '',

	inserted: false,
	isModified: false,
};

export type EQM2070_R01OxCellValue = "" | "O" | "X";

export interface EQM2070_R01DetailPivotDto {
	valueIndex: number;
	eqmType: string;
	eqmTypeNm?: string;
	inspectCd: string;
	inspectNm: string;
	dayValues: Record<string, EQM2070_R01OxCellValue>;
	dayMeta: Record<string, { itemNo?: string }>;
	isModified?: boolean;
	inserted?: boolean;
}

export const defaultEQM2070_R01DetailPivotDto: EQM2070_R01DetailPivotDto = {
	valueIndex: 0,
	eqmType: "",
	eqmTypeNm: "",
	inspectCd: "",
	inspectNm: "",
	dayValues: {},
	dayMeta: {},
	isModified: false,
};
